export default __webpack_public_path__ + "static/media/MaskGroup.9b85c660.svg";